import {$} from './constants';
import { initYT } from './youtube';

$(function () {

    initYT();

    const $container = $('#terminal_grid_container');
    const $input = $('#terminal-search-input');
    if (!$container.length) return;
    let timer = null;

    function fetchTerminals(page = 1) {
        const search = $.trim($input.val());
        $.ajax({
            url: cltvo_js_vars.ajax_url,
            type: 'POST',
            data: {
                action: 'terminal',
                search: search,
                paged: page,
            },
            beforeSend: function () {
                $container.addClass('is-loading');
            },
            success: function (response) {
                $container.html(response);
            },
            error: function (xhr) {
                console.error('AJAX ERROR', xhr.status, xhr.responseText);
            },
            complete: function () {
                $container.removeClass('is-loading');
            },
        });
    }

    $input.on('input', function () {
        clearTimeout(timer);

        const search = $.trim($input.val());

        timer = setTimeout(function () {
            if (search.length >= 3 || search.length === 0) {
                fetchTerminals(1);
            }
        }, 350);
    });

    $(document).on('click', '.btn--prev-terminal, .btn--next-terminal, .terminal-template__grid-pagination-pages .page-num', function (e) {
        e.preventDefault();

        const $btn = $(this);

        if ($btn.hasClass('disabled') || $btn.hasClass('active') || $btn.is(':disabled')) {
            return;
        }

        const page = parseInt($btn.data('page'), 10);

        console.log('pagination click', page);

        if (!page) return;

        fetchTerminals(page);
    });
});

$(function () {

    function getFallbackImages($wrapper) {
        return {
            $desktop: $wrapper.find('.image-fallback-desktop'),
            $mobile: $wrapper.find('.image-fallback-mobile')
        };
    }

    function prepareFallback($wrapper) {
        const isMobile = window.matchMedia('(max-width: 950px)').matches;
        const images = getFallbackImages($wrapper);

        // La imagen correcta debe estar visible desde el inicio
        if (isMobile) {
            images.$desktop.hide();
            images.$mobile.show();
        } else {
            images.$mobile.hide();
            images.$desktop.show();
        }

        // El video comienza oculto y solo aparece al reproducirse
        $wrapper
            .addClass('video-fallback-active')
            .removeClass('video-playing');

        $wrapper.find('.js-video-fallback').css({
            opacity: 0,
            visibility: 'hidden',
            pointerEvents: 'none'
        });
    }

    function showVideo($wrapper, video) {
        if ($wrapper.hasClass('video-fallback-forced')) {
            return;
        }

        $wrapper
            .removeClass('video-fallback-active')
            .addClass('video-playing');

        $(video).css({
            opacity: 1,
            visibility: 'visible'
        });
    }

    function showFallback($wrapper, video) {
        if ($wrapper.hasClass('video-fallback-forced')) {
            return;
        }

        $wrapper
            .addClass('video-fallback-active video-fallback-forced')
            .removeClass('video-playing');

        if (video) {
            try {
                video.pause();
            } catch (error) {
                // No interrumpir el resto del sitio
            }

            $(video).css({
                opacity: 0,
                visibility: 'hidden',
                pointerEvents: 'none'
            });
        }

        const isMobile = window.matchMedia('(max-width: 950px)').matches;
        const images = getFallbackImages($wrapper);

        if (isMobile) {
            images.$desktop.hide();
            images.$mobile.show();
        } else {
            images.$mobile.hide();
            images.$desktop.show();
        }
    }

    function handleVideoFallback() {
        $('.js-video-fallback-wrapper').each(function () {
            const $wrapper = $(this);
            const $videos = $wrapper.find('.js-video-fallback');

            prepareFallback($wrapper);

            $videos.each(function () {
                const video = this;
                let hasPlayed = false;

                if (!video) {
                    return;
                }

                video.muted = true;
                video.defaultMuted = true;
                video.playsInline = true;

                video.setAttribute('muted', '');
                video.setAttribute('playsinline', '');
                video.setAttribute('webkit-playsinline', '');

                video.addEventListener('playing', function () {
                    hasPlayed = true;
                    showVideo($wrapper, video);
                }, { once: true });

                video.addEventListener('error', function () {
                    showFallback($wrapper, video);
                }, { once: true });

                video.addEventListener('stalled', function () {
                    if (!hasPlayed) {
                        showFallback($wrapper, video);
                    }
                }, { once: true });

                video.addEventListener('abort', function () {
                    if (!hasPlayed) {
                        showFallback($wrapper, video);
                    }
                }, { once: true });

                const playPromise = video.play();

                if (
                    playPromise &&
                    typeof playPromise.catch === 'function'
                ) {
                    playPromise.catch(function () {
                        showFallback($wrapper, video);
                    });
                }

                // iOS puede no rechazar play(), pero tampoco reproducir
                setTimeout(function () {
                    if (
                        !hasPlayed ||
                        video.paused ||
                        video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA
                    ) {
                        showFallback($wrapper, video);
                    }
                }, 1800);
            });
        });
    }

    $(window).on('load', handleVideoFallback);

    $(window).on('resize orientationchange', function () {
        $('.js-video-fallback-wrapper.video-fallback-active').each(function () {
            prepareFallback($(this));
        });
    });

});